// extracted by mini-css-extract-plugin
export default {"div":"GoBack_div__+7X6Z"};